exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renewal-content[data-v-20f98cff]{width:100%;margin-bottom:10px}.renewal-content p[data-v-20f98cff]{width:50%;margin:12px 20px 0 0;padding:0;font-size:13px;display:inline-block}.renewal-content p[data-v-20f98cff]:last-of-type{margin-right:0}\n", ""]);

// exports
